<div class="main-content">
  <div class="nav-area"><app-nav-footer></app-nav-footer></div>
  <div class="main-content-input">
    <app-header></app-header>
    <div class="contact-list-content"> <app-overlay-contacts></app-overlay-contacts>
      <app-contact-list class="contact-list-component"></app-contact-list>
      <app-info-screen class="info-screen-component"></app-info-screen>
      <app-info-screen-mobile class="app-info-screen-mobile-component hidden"></app-info-screen-mobile>
    </div>
  </div>
</div>
<div class="createdContact" >Contact successfully created</div>
<app-nav-footer-mobile></app-nav-footer-mobile>